/**
 * Switch — Free-shipping unlock badge (Kaching Bundles aware).
 *
 * Shows blocks/switch-free-shipping.liquid's message once the shopper's
 * selected Kaching quantity (the `quantity` field, packs count) reaches the
 * block's configured minimum, hides it again below that. Doesn't care about
 * price at all — just the quantity field.
 *
 * Uses the same trigger strategy as switch-unit-price.js (proven to survive
 * Kaching re-rendering its widget): delegated change/input listeners on
 * document, plus a MutationObserver on Kaching's own elements as a
 * structural fallback, plus a short startup poll to correct any pre-selected
 * tier once Kaching finishes painting.
 *
 * TWO KACHING LAYOUTS (verified live, 2026-07): the multi-bar layout
 * ("N Packs" radios) renders inside `.kaching-bundles .kaching-bundles__bar`,
 * and a native radio `change` event fires on selection — that layout was
 * always covered. The single-bar "stepper" layout (+/- quantity buttons)
 * instead renders a `<kaching-bundle>` custom element that sits OUTSIDE
 * `.kaching-bundles` entirely, and its +/- buttons update the quantity input
 * via direct property assignment with NO `change`/`input` event dispatched —
 * confirmed by instrumenting document-level listeners live, only a bare
 * `click` fires. The old code observed only `.kaching-bundles`, so it never
 * saw this element's mutations and the badge froze. Now WIDGET_SELECTORS
 * covers both, and observers attach to whichever is present (`<kaching-
 * bundle>` may not exist yet at init — Kaching renders async — so the poll
 * also (re)attaches once it appears, not just on the original widget).
 */
(function () {
  'use strict';

  var BADGE_SEL = '[data-switch-free-shipping]';
  var WIDGET_SEL = '.kaching-bundles';
  var BAR_SEL = '.kaching-bundles__bar';
  var OBSERVE_SEL = '.kaching-bundles, kaching-bundle';

  function currentPacks() {
    var q = document.querySelector('input[name="quantity"]');
    var n = q ? parseInt(q.value, 10) : NaN;
    return isFinite(n) && n > 0 ? n : 1;
  }

  function updateAll() {
    var packs = currentPacks();
    var badges = document.querySelectorAll(BADGE_SEL);
    for (var i = 0; i < badges.length; i++) {
      var badge = badges[i];
      var min = parseInt(badge.dataset.minPacks, 10) || 1;
      badge.classList.toggle('switch-free-shipping--pending', packs < min);
    }
  }

  function init() {
    if (!document.querySelector(BADGE_SEL)) return;

    var raf = null;
    var schedule = function () {
      if (raf) return; // coalesce bursts
      raf = requestAnimationFrame(function () { raf = null; updateAll(); });
    };

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t) return;
      if ((t.name && t.name.indexOf('kaching-bundles-deal') === 0) || t.name === 'quantity') schedule();
    });
    document.addEventListener('input', function (e) {
      if (e.target && e.target.name === 'quantity') schedule();
    });

    // Attach a MutationObserver to every not-yet-observed Kaching root
    // currently in the DOM. Safe to call repeatedly (e.g. from the poll)
    // since already-observed elements are marked and skipped.
    var observed = typeof WeakSet === 'function' ? new WeakSet() : null;
    function attachObservers() {
      if (typeof MutationObserver !== 'function') return;
      document.querySelectorAll(OBSERVE_SEL).forEach(function (el) {
        if (observed) {
          if (observed.has(el)) return;
          observed.add(el);
        } else if (el.__switchFreeShipObserved) {
          return;
        } else {
          el.__switchFreeShipObserved = true;
        }
        new MutationObserver(schedule).observe(el, { childList: true, subtree: true, characterData: true });
      });
    }
    attachObservers();

    updateAll(); // correct any pre-selected tier on load

    // Kaching renders asynchronously — re-run a few times until it has painted
    // its bars/stepper, (re)attaching observers each time in case `<kaching-
    // bundle>` was inserted after the elements above were first checked.
    var tries = 0;
    (function poll() {
      attachObservers();
      var widget = document.querySelector(WIDGET_SEL);
      var rendered = (widget && widget.querySelector(BAR_SEL)) || document.querySelector('kaching-bundle');
      if (rendered) { updateAll(); return; }
      if (tries++ < 40) setTimeout(poll, 250); // ~10s ceiling, then give up (no Kaching)
    })();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();